import { InputBlockType } from './inputBlock';
export const BlockWithMultipleAnswer = [
    InputBlockType.INPUT_CHECKBOXES,
    InputBlockType.INPUT_STRING_TEXT_BOXES,
    InputBlockType.INPUT_MULTI_OPTION_SELECT
];
